import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import useLocationStore from './locatonStore';
import useBgColorStore from './bgColor';
import { getLocationNameFromOwnerId } from '../utils/utility';
import { locationConstant } from '../constants/constant';

export interface IUser {
  id: number;
  firstName: string;
  lastName: string;
  staffName: string;
  ownerId: number;
  userName: string;
  accessLevelId: number;
  staffId?: number;
}

export interface IToken {
  access: string;
  expiryDate: string;
}

interface UserStore {
  user: IUser | null;
  token: IToken | null;
  hasHydrated: boolean;
  setUserDetails: (user: IUser, token: IToken) => void;
  clearUserDetails: () => void;
}

const useUserStore = create<UserStore>()(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      hasHydrated: false,

      setUserDetails: (user, token) => {
        set({ user, token });

        const locationStore = useLocationStore.getState();
        const { isUserSelected } = locationStore;

        // ✅ Only set location from API if user hasn’t selected manually
        if (!isUserSelected) {
          locationStore.setSelectedLocation(
            {
              locationName: getLocationNameFromOwnerId(user.ownerId),
              OwnerId: user.ownerId,
              defaultLat: locationConstant.defaultLat, 
              defaultLon: locationConstant.defaultLon
            },
            false // system-selected, not user
          );
        }

        const bgColorStore = useBgColorStore.getState();
        bgColorStore.updateBgColor();
        bgColorStore.updateMainBgColor();
      },

      clearUserDetails: () => {
        set({ user: null, token: null });

        useLocationStore.getState().clearLocationStore();

        const bgColorStore = useBgColorStore.getState();
        bgColorStore.clearBgColorStore();
        bgColorStore.updateMainBgColor();
      },
    }),
    {
      name: 'user-storage',
      partialize: (state) => ({
        user: state.user,
        token: state.token,
      }),
      onRehydrateStorage: () => () => {
        useUserStore.setState({ hasHydrated: true });
      },
    }
  )
);

export default useUserStore;
